// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CenterView_wrap__1sYRl","content":"CenterView_content__2ZJQ1"};